import { updateFrozenDocumentStoreRevId } from '../DocumentStore'

export default async function (bcDocumentStore, revId, $router) {
  // have to reload document
  bcDocumentStore.willChangeRevision = true
  updateFrozenDocumentStoreRevId(bcDocumentStore.document.id, bcDocumentStore.documentRev, revId)
  if ($router && !bcDocumentStore.willUserLeave) {
    console.log('will change revision')
    await $router.replace({
      name: 'BCDocumentDetailRev',
      params: { revId: revId }
    })
  } else {
    await bcDocumentStore.loadDocument(bcDocumentStore.document.id, revId)
  }
}